import { push } from 'redux-first-history';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api';
import { User } from 'models/User';


export const UserActionType = {
    ADD_ROLE: "ADD_ROLE",
    ADD_ROLE_SUCCESS: "ADD_ROLE_SUCCESS",
    ADD_USER: "ADD_USER",
    ADD_USER_SUCCESS: "ADD_USER_SUCCESS",
    EDIT_USER: "EDIT_USER",
    EDIT_USER_SUCCESS: "EDIT_USER_SUCCESS",
    DELETE_USER: "DELETE_USER",
    DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
    REMOVE_ROLE: "REMOVE_ROLE",
    REMOVE_ROLE_SUCCESS: "REMOVE_ROLE_SUCCESS",
    FETCH_ALLUSERDATA: 'FETCH_ALLUSERDATA',
    FETCH_ALLUSERDATA_SUCCESS: 'FETCH_ALLUSERDATA_SUCCESS',
    API_ERROR: 'API_ERROR',
};

export interface LoginData {
    email: string,
    password: string
}

export interface ChangePasswordData {
    newPassword: string,
    confirmNewPassword: string,
    oldPassword: string
}

export interface ChangeRoleData {
    userEMail: string,
    roleId: string
}

interface IFetchAllUserDataAction {
    type: typeof UserActionType.FETCH_ALLUSERDATA
    payload: ApiPayload,
    returnPayload: User[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddRole {
    type: typeof UserActionType.ADD_ROLE
    payload: ApiPayload,
    returnPayload: User,
    meta: {
        isApiCall: boolean
    },
    token: string
}

interface IRemoveRole {
    type: typeof UserActionType.REMOVE_ROLE
    payload: ApiPayload,
    returnPayload: User,
    meta: {
        isApiCall: boolean
    },
    token: string
}

interface IAddUser {
    type: typeof UserActionType.ADD_USER
    payload: ApiPayload,
    returnPayload: User,
    meta: {
        isApiCall: boolean
    },
    token: string
}

interface IEditUser {
    type: typeof UserActionType.EDIT_USER
    payload: ApiPayload,
    returnPayload: User,
    meta: {
        isApiCall: boolean
    },
    token: string
}

interface IDeleteUser {
    type: typeof UserActionType.DELETE_USER
    payload: ApiPayload,
    returnPayload: User,
    meta: {
        isApiCall: boolean
    },
    token: string
}

interface IMoveToXUser {

}

export type IUserActions = IFetchAllUserDataAction & IAddRole & IRemoveRole & IMoveToXUser & IAddUser & IEditUser & IDeleteUser;


export class UserActions {
    public static addRole(token: string, roleData: ChangeRoleData): UserActions {
        return {
            type: UserActionType.ADD_ROLE,
            payload: Api.postApiCall('api/UserData/addRole', token, UserActionType.ADD_ROLE_SUCCESS, UserActionType.API_ERROR, roleData, true),
            meta: {
                isApiCall: true
            },
        }
    }

    public static removeRole(token: string, roleData: ChangeRoleData): UserActions {
        return {
            type: UserActionType.REMOVE_ROLE,
            payload: Api.postApiCall('api/UserData/removeRole', token, UserActionType.REMOVE_ROLE_SUCCESS, UserActionType.API_ERROR, roleData, true),
            meta: {
                isApiCall: true
            },
        }
    }

    public static fetchAllUserData(token: string): UserActions {
        return {
            type: UserActionType.FETCH_ALLUSERDATA,
            payload: Api.fetchApiCall('api/UserData/All', token, UserActionType.FETCH_ALLUSERDATA_SUCCESS, UserActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addUser(token: string, userData: User): UserActions {
        return {
            type: UserActionType.ADD_USER,
            payload: Api.postApiCall('api/UserData', token, UserActionType.ADD_USER_SUCCESS, UserActionType.API_ERROR, userData, true),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editUser(token: string, userData: User): UserActions {
        return {
            type: UserActionType.EDIT_USER,
            payload: Api.putApiCall('api/UserData', token, UserActionType.EDIT_USER_SUCCESS, UserActionType.API_ERROR, userData, true),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteUser(token: string, userData: User): UserActions {
        return {
            type: UserActionType.DELETE_USER,
            payload: Api.deleteApiCall('api/UserData/' + userData.email, token, UserActionType.DELETE_USER_SUCCESS, UserActionType.API_ERROR, true),
            meta: {
                isApiCall: true
            },
        }
    }

    public static moveToEditUser(id: number): UserActions {
        return push("/Users/edit/" + id)
    }

    public static moveToAddUser(): UserActions {
        return push("/Users/add")
    }
}

